import { all, fork } from 'redux-saga/effects';
import { map } from 'lodash/fp';
import { sagas as admin } from '../admin';
import { sagas as auth } from '../auth';
import { sagas as contacts } from '../contacts';
import { sagas as errors } from '../errors';
import { sagas as writing } from '../writing';
import { sagas as newContacts } from '../new-contacts';
import { sagas as newsletter } from '../newsletter';
import { sagas as newsletters } from '../newsletters';
import { sagas as outbox } from '../outbox';
import { sagas as schools } from '../schools';
import { sagas as notification } from '../notification';

const sagas = {
  ...admin,
  ...auth,
  ...contacts,
  ...errors,
  ...writing,
  ...newContacts,
  ...newsletter,
  ...newsletters,
  ...outbox,
  ...schools,
  ...notification,
};

export default function* rootSaga() {
  yield all(map(saga => fork(saga), sagas));
}
